import { rest } from '@ax2/common/index';
import PasswordResetRequest from '../model/password-reset/PasswordResetRequest';
import TokenValidationRequest from '../model/password-reset/TokenValidationRequest';
import NewPasswordRequest from '../model/password-reset/NewPasswordRequest';

export type RestError = rest.RestError;

export function requestPasswordReset(
  data: PasswordResetRequest
): Promise<void> {
  return rest.api<void>('/client/password-reset/email', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf8',
    },
    data: JSON.stringify(data),
  });
}

export function validatePasswordResetToken(
  data: TokenValidationRequest
): Promise<void> {
  return rest.api<void>('/client/password-reset/validate', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(data),
  });
}

export function setNewPassword(data: NewPasswordRequest): Promise<void> {
  return rest.api<void>('/client/password-reset', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(data),
  });
}
